module.exports = __webpack_public_path__ + "media/images/adminAvatar-97bf34f1d09cc53985bb51f3056383aa.png";